import { dialog } from "../../nq-component";
import BaseFormPresenter from "../../base/BaseFormPresenter";
import { html, image } from "framer-motion/client";
import DialogWarning from "./components/DialogWarning";

class ApplicationFormPresenter extends BaseFormPresenter {
  constructor(view, upsertUseCase, signOutUseCase, findObjectUseCase) {
    super();
    this.view = view;
    this.upsertUseCase = upsertUseCase;
    this.signOutUseCase = signOutUseCase;
    this.findObjectUseCase = findObjectUseCase;
    this.personal = {};
    this.employmentBackground = [];
    this.characterref = [];
    this.recruiter = null;

    this.onChangeEmployment = this.onChangeEmployment.bind(this);
    this.onChangecharacteref = this.onChangecharacteref.bind(this);
  }

  onChangeObject(object) {
    this.change = object;
    this.object = object;
  }

  componentDidMount() {
    this.init();
    return this.getObjects();
  }
  init() {
    this.limit = 20;
    this.where = {};
    this.search = {};
    this.filter = {};
    this.include = ["all"];
    this.keys = undefined;
    this.sort = { createdAt: -1 };
    this.progress = true;
    this.reset();
  }

  async getObjects() {
    const collection = "users";
    const query = {
      include: ["employee"],
      where: { "roles.id": "Recruiter" },
    };

    try {
      this.findObjectUseCase.abort();
      const objects = await this.findObjectUseCase.execute(collection, query);

      // const employeeIds = objects.map((item) => item.employee.id);

      // const roleIds = { employeeIds };

      this.view.setState({ recruiters: objects });
    } catch (error) {
      console.error("Error in findObjects:", error);
      this.view.showError(error);
    } finally {
      this.progress = false;
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.recruiters !== this.state.recruiters) {
      this.init();
    }
  }

  reset() {
    if (this.view.state.recruiters.length === 0) {
      this.view.setState({ recruiters: [] });
    }
  }

  onChangeEmployment(value, field, id) {
    if (!id) return;
    const index = this.employmentBackground.findIndex((emp) => emp.id === id);
    if (index !== -1) {
      this.employmentBackground[index] = {
        ...this.employmentBackground[index],
        [field]: value,
      };
    }
  }

  onChangecharacteref(value, field, id = crypto.randomUUID()) {
    let index = this.characterref.findIndex((emp) => emp.id === id);
    if (index === -1) {
      this.characterref.push({ id });
      index = this.characterref.length - 1;
    }
    this.characterref[index][field] = value;
  }

  // onChangePersonal(value, field) {
  //   this.personal[field] = value;
  //   const isAddressSame = this.view.state.isAddressSame;
  // }
  deleteImage() {
    delete this.personal["image1"];
  }
  removeAllIsUntilPresentEmployment() {
    this.employmentBackground = this.employmentBackground.map((entry) => {
      const { isUntilPresentEmployment, ...rest } = entry;

      if (isUntilPresentEmployment === true) {
        delete rest.dateEmployedTo;
      }

      return rest;
    });
  }

  exludedFields() {
    if (this.personal.isUntilPresent === true) {
      delete this.personal.yearEndDateHs;
    }
    if (this.personal.isUntilPresentCol === true) {
      delete this.personal.yearEndDateCol;
    }
    delete this.personal.isUntilPresent;
    delete this.personal.isUntilPresentCol;
  }

  syncAddress() {
    this.personal["permanent_houseNumber"] =
      this.personal["present_houseNumber"];
    this.personal["permanent_street"] = this.personal["present_street"];
    this.personal["permanent_subdivision"] =
      this.personal["present_subdivision"];
    this.personal["permanent_barangay"] = this.personal["present_barangay"];
    this.personal["permanent_city"] = this.personal["present_city"];
    this.personal["permanent_province"] = this.personal["present_province"];
    this.personal["permanent_zipCode"] = this.personal["present_zipCode"];
    this.personal["telephone"] = this.personal["present_telephone"];
  }

  syncContactPersonAdress() {
    this.personal["contact_houseNumber"] = this.personal["present_houseNumber"];
    this.personal["contact_street"] = this.personal["present_street"];
    this.personal["contact_subdivision"] = this.personal["present_subdivision"];
    this.personal["contact_barangay"] = this.personal["present_barangay"];
    this.personal["contact_city"] = this.personal["present_city"];
    this.personal["contact_province"] = this.personal["present_province"];
    this.personal["contact_zipCode"] = this.personal["present_zipCode"];
    this.personal["contact_telephone"] = this.personal["present_telephone"];
  }

  onChangePersonal(value, field) {
    this.personal[field] = value;

    this.view.setState({ personal: { ...this.personal } });
    console.log(this.personal);
  }

  onChangeRecruiter(event) {
    const selectedRecruiterId = event.target.value;
    this.recruiter = selectedRecruiterId;
  }

  removeEmployment(id) {
    delete this.employmentBackground[id];
  }

  removeCharacterRef(id) {
    delete this.characterref[id];
  }

  validateInputs() {
    const uploadedImage = this.view.state.image;
    // if (!this.personal["coe"] || this.personal["coe"].trim() === "") {
    //   return false;
    // }

    // if (
    //   !this.personal["trainingCertificate"] ||
    //   this.personal["trainingCertificate"].trim() === ""
    // ) {
    //   return false;
    // }

    return true;
  }
  async submitForm() {
    const recruiterId = this.recruiter;
    const user = this.view.getCurrentUser();
    const { isAddressSame, addressSameApplicant } = this.view.state;
    const selectedJobs = localStorage.getItem("selectedJobs");
    const selectJobsId = [];
    this.exludedFields();
    this.removeAllIsUntilPresentEmployment();

    if (selectedJobs.length > 0) {
      const parsedData = JSON.parse(selectedJobs);
      parsedData.map((object) => {
        selectJobsId.push({ id: object?.id });
      });
    }

    if (isAddressSame) {
      this.syncAddress();
    }
    if (addressSameApplicant) {
      this.syncContactPersonAdress();
    }
    try {
      this.view.showProgress();

      const employmentReferences = await Promise.all(
        this.employmentBackground.map(async (employment) => {
          const result = await this.upsertUseCase.execute(
            "employment_background",
            employment
          );
          return result;
        })
      );

      const characterrefData = await Promise.all(
        this.characterref.map(async (ref) => {
          const result = await this.upsertUseCase.execute(
            "character_references",
            ref
          );
          return result;
        })
      );

      const referenceNo = this.view.generateReferenceNumber();
      this.personal["image1"] = this.view.state.image;
      let application = {};
      if (!recruiterId) {
        application = {
          ...this.personal,
          status: "New",
          applicant: {
            id: user?.id,
          },
          email: user?.email,
          interviewCoordinator: "online",
          positionDesired: selectJobsId,
          referenceNumber: referenceNo,
          employmentBackground: employmentReferences,
          characterReferences: characterrefData,
        };
      } else {
        application = {
          ...this.personal,
          status: "New",
          applicant: {
            id: user?.id,
          },
          email: user?.email,
          positionDesired: selectJobsId,
          recruiter: {
            id: recruiterId,
          },
          interviewCoordinator: "online",
          referenceNumber: referenceNo,
          employmentBackground: employmentReferences,
          characterReferences: characterrefData,
        };

        const applicantsName = `${this.personal?.firstName} ${this.personal?.lastName}`;
        const report = {
          recruiter: {
            id: recruiterId,
          },
          status: "invited",
          applicant: applicantsName,
        };

        await this.upsertUseCase.execute("recruiters_report", report);
      }

      const applicationData = await this.upsertUseCase.execute(
        "online_applicants",
        application
      );

      this.view.showSuccessSnackbar(
        "The application form has been successfully submitted! Please wait for an email regarding your interview schedule.",
        "Application Submitted"
      );
      this.view.navigateTo("/jobportal");
    } catch (error) {
      this.view.hideProgress();
      this.view.showError(error);
      this.view.setState({ isSubmitting: false });
    }
  }

  removeSelectedJobs() {
    localStorage.removeItem("selectedJobs");
  }

  onClickSignOut() {
    const options = {
      title: "Confirm",
      message: "Are you sure you want to sign out?",
      positiveButton: "SIGN OUT",
    };

    this.view
      .showDialog(options)
      .then(() => this.signOutUseCase.execute())
      .then(() => {
        localStorage.removeItem("selectedJobs");
        localStorage.removeItem("user");
        this.view.navigateTo("/signin");
      })
      .catch((error) => {
        this.view.showError(error);
      });
  }
}

export default ApplicationFormPresenter;
